import Vue from 'vue'
const bus = new Vue()
 
export default (app,inject) => {
    inject('bus',bus)
}